import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }

  .recorder-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
  }

  .preview-wrapper {
    position: relative;
    flex: 1;
    width: 100%;
    min-height: 0;
    overflow: hidden;
  }

  .preview-wrapper.hidden {
    display: none;
  }

  .preview-wrapper.paused video {
    filter: brightness(0.5);
  }

  .paused-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 2px;
    text-shadow: 0 2px 4px rgb(0 0 0 / 0.5);
    pointer-events: none;
  }

  video {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: scaleX(-1); /* Mirror for self-view */
  }

  @media (max-width: 768px) {
    .recorder-container {
      padding: 8px;
      gap: 12px;
    }

    .preview-wrapper {
      border-radius: 0;
      border-left: none;
      border-right: none;
      margin: 0 -8px;
      width: calc(100% + 16px);
    }
  }

  /* Mobile landscape: remove all padding for maximum video space */
  @media (max-height: 500px) and (orientation: landscape) {
    .recorder-container {
      padding: 0;
      gap: 0;
    }

    .preview-wrapper {
      margin: 0;
      width: 100%;
      border-radius: 0;
    }

    .paused-overlay {
      font-size: 16px;
    }
  }

  .controls {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .stream-button {
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition:
      background-color 0.2s,
      opacity 0.2s;
  }

  .stream-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .stream-button.start {
    background: var(--color-success, #22c55e);
    color: white;
  }

  .stream-button.start:hover:not(:disabled) {
    background: var(--color-success-hover, #16a34a);
  }

  .stream-button.stop {
    background: var(--color-danger, #ef4444);
    color: white;
  }

  .stream-button.stop:hover:not(:disabled) {
    background: var(--color-danger-hover, #dc2626);
  }

  .status-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: var(--color-text-secondary, #888);
  }

  .status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--color-text-tertiary, #444);
  }

  .status-dot.streaming {
    background: var(--color-success, #22c55e);
    animation: pulse 1.5s infinite;
  }

  .status-dot.starting {
    background: var(--color-warning, #f59e0b);
    animation: pulse 0.8s infinite;
  }

  .status-dot.error {
    background: var(--color-danger, #ef4444);
  }

  .status-dot.paused {
    background: var(--color-warning, #f59e0b);
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }

  .error-message {
    color: var(--color-danger, #ef4444);
    font-size: 14px;
    text-align: center;
    max-width: 400px;
  }
`;
